export const DEFAULT_WEIGHTS = {
  // 基础指标
  rating: 0,
  totalTrails: 20,
  verticalDrop: 20,
  lifts: 10,

  // 雪道长度
  beginnerTrails: 0,
  intermediateTrails: 0,
  advancedTrails: 0,

  // 气候指标
  snowFall: 0,
  snowDepth: 0,
  snowExistDays: 0,
  snowDaysYearly: 0,
  temperature: 0,
  windSpeed: 0,

  // 交通指标
  cityDistance: 0,
  majorCityDistance: 0,
  airportDistance: 0,
  trainDistance: 0,

  // 价格指标
  price: 0
};

export const SNOW_WEIGHTS = {
  ...DEFAULT_WEIGHTS,
  snowFall: 20,
  snowDepth: 15,
  snowExistDays: 15,
  snowDaysYearly: 0
}; 